/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PageStatusCodeQueryVariables = GraphQL.Exact<{
  legacyUrlId: GraphQL.Scalars['Int']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type PageStatusCodeQuery = { readonly __typename?: 'Query', readonly lookupPageByLegacyId: { readonly __typename?: 'Page', readonly id: CK.UrlId, readonly statusCode: number | null } | null };


export const PageStatusCodeDocument = gql`
    query PageStatusCode($legacyUrlId: Int!, $websiteId: WebsiteId!) {
  lookupPageByLegacyId(legacyUrlId: $legacyUrlId, websiteId: $websiteId) {
    id
    statusCode
  }
}
    `;

/**
 * __usePageStatusCodeQuery__
 *
 * To run a query within a React component, call `usePageStatusCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageStatusCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageStatusCodeQuery({
 *   variables: {
 *      legacyUrlId: // value for 'legacyUrlId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function usePageStatusCodeQuery(baseOptions: Apollo.QueryHookOptions<PageStatusCodeQuery, PageStatusCodeQueryVariables> & ({ variables: PageStatusCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageStatusCodeQuery, PageStatusCodeQueryVariables>(PageStatusCodeDocument, options);
      }
export function usePageStatusCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageStatusCodeQuery, PageStatusCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageStatusCodeQuery, PageStatusCodeQueryVariables>(PageStatusCodeDocument, options);
        }
export function usePageStatusCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageStatusCodeQuery, PageStatusCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageStatusCodeQuery, PageStatusCodeQueryVariables>(PageStatusCodeDocument, options);
        }
export type PageStatusCodeQueryHookResult = ReturnType<typeof usePageStatusCodeQuery>;
export type PageStatusCodeLazyQueryHookResult = ReturnType<typeof usePageStatusCodeLazyQuery>;
export type PageStatusCodeSuspenseQueryHookResult = ReturnType<typeof usePageStatusCodeSuspenseQuery>;
export type PageStatusCodeQueryResult = Apollo.QueryResult<PageStatusCodeQuery, PageStatusCodeQueryVariables>;